<template>
    <div class="distribution" :class="{ full: isFull }">
        <Title chineseTitle="配电图" englishTitle="Distribution chart" />
        <div class="distributionContent" :class="{ full: isFull }">
            <div class="title row-center" @click="showDiagramList = !showDiagramList" v-show="!isFull">
                <img src="@/assets/img/change.png" alt="" />
                <span>{{currentName}}</span>
                <!-- <span>{{details.find(item=>item.id==areaId).name}}</span> -->
            </div>
            <div class="list" v-show="showDiagramList && !isFull">
                <img class="close" @click="showDiagramList = false" src="@/assets/img/close.png" alt="关闭" />
                <!-- 类型 -->
                <div class="type row-center">
                    <span class="active">配电图列表</span>
                </div>
                <!-- 列表 -->
                <div class="names">
                    <span style="cursor: pointer;" v-for="(item, index) in details" :class="{ active: item.id == currentId }" :key="index"
                        @click="currentId = item.id,getCurrentInfo(currentId)">{{ item.name }}</span>
                </div>
            </div>
            <!-- 全屏按钮 -->
            <div class="btn row-center" v-if="!isFull" @click="isFull = true">
                <img src="@/assets/img/fullScreen.png" alt="全屏" />
                <span>全屏</span>
            </div>

            <!-- 内容 -->
            <diagram @onCancelFull="isFull = false" :isFull="isFull" class="diagram" :src="currentUrl">
            </diagram>
        </div>
    </div>
</template>

<script>
    import Title from "@/components/Title";
    import Diagram from "@/components/Diagram";

    export default {
        name: "Distribution",
        components: {
            Title,
            Diagram,
        },
        props: ["areaId"],
        data() {
            return {
                currentName: '',
                currentUrl: '',
                currentId: '',
                showDiagramList: false,
                isFull: false,
                details: this.$store.state.distribution,
            };
        },
        mounted() {
            this.areaId == -1 ? (this.currentId = this.details[0].id) : (this.currentId = this.areaId)
            this.getCurrentInfo(this.currentId)
        },
        methods: {
            getCurrentInfo(id) {
                this.details.forEach((item, index) => {
                    if (item.id == id) {
                        this.currentName = item.name
                        this.currentUrl = item.url
                    }
                })
            },
        }
    };
</script>

<style lang="less" scoped>
    .list {
        width: 100%;
        height: 100%;
        position: absolute;
        left: -4080/192vw;
        top: 0;
        color: #ffffff;
        font-size: 18px;
        background-image: url("../../assets/img/安防列表.png");
        background-size: 100% 100%;
        padding-top: 23px;
        padding-left: 24px;
        padding-right: 18px;

        .close {
            position: absolute;
            top: 23px;
            right: 20px;
            cursor: pointer;
        }

        .active {
            color: #0d94ff;
        }

        .names {
            height: 75%;
            display: flex;
            flex-direction: column;
            overflow-y: auto;
            align-items: flex-start;

            span {
                margin-bottom: 23px;
            }
        }

        .type {
            justify-content: flex-start;
            border-bottom: 1px solid rgba(255, 255, 255, 0.75);
            margin-bottom: 16px;

            span {
                margin-right: 33px;
                margin-bottom: 13px;
            }
        }
    }

    .full {
        overflow: hidden !important;
        width: 100vw !important;
        height: 100 - 72 * 100 /1080vh !important;
        position: fixed !important;
        left: 0 !important;
        top: 72 * 100 / 1080vh !important;
        margin: 0 !important;
        padding: 0 !important;
        z-index: 999 !important;
        background: #000 !important;
        opacity: 1 !important;

        .diagram {
            width: 100% !important;
            height: 100% !important;
            /*position: fixed !important;*/
            left: 0 !important;
            top: 0 !important;
        }
    }

    .distribution {
        position: fixed;
        top: 6800/108vh;
        left: 14600/192vw;
    }

    .distributionContent {
        width: 4000/192vw;
        height: 3000/108vh;
        background-color: rgba(3, 13, 24, 0.75);

        margin-left: 1vw;
        /*overflow: hidden;*/

        position: relative;

        .title {
            position: absolute;
            left: 12px;
            top: 16px;
            font-size: 18px;
            color: #e6f3fd;
            height: 24 / 1080 * 100vh;
            z-index: 999;
            cursor: pointer;

            img {
                margin-right: 11px;
                width: 16px;
                height: 13px;
            }
        }

        .btn {
            .wh(12, 16);
            position: absolute;
            top: @h;
            right: @w;
            z-index: 99999;
            color: #ffffff;
            font-size: 18px;
            cursor: pointer;

            img {
                .wh(16, 16);
                width: @w;
                height: @h;
                margin-right: 7 / 1920 * 100vw;
            }
        }

        .diagram {
            width: 376 / 1920 * 100vw;
            height: 242 / 1080 * 100vh;
            position: absolute;
            left: 12px;
            top: 46px;
        }
    }

    
    .names::-webkit-scrollbar {
        width: 5px;
        height: 1px;
    }

    .names::-webkit-scrollbar-thumb {
        border-radius: 5px;
        box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: rgba(255, 255, 255, 0.7);
    }

    // .names::-webkit-scrollbar-track {
    //     box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    //     border-radius: 10px;
    //     background: #111;
    // }
    
</style>